import gql from "graphql-tag";

export const CreatePartnerAlert = gql`
  mutation CreatePartnerAlert($AlertType: AdditionalServices! $PartnerId: PartnerId! $ProfileId: ProfileId! $Resolved: false) {
    CreatePartnerAlert(AlertType: $AdditionalServices, PartnerId: $PartnerId, ProfileId: $ProfileId, Resolved: $Resolved) {
      AlertType
      CreatedAt
      PartnerAlertId
      PartnerId
      ProfileId
      Resolved
      ResolvedAt
      UpdatedAt
    }
  }
`;

export const GetPartnerAlert = gql`
  query GetPartnerAlert (
    $PartnerAlertId: ID!
    ) {
    GetPartnerAlert (
      PartnerAlertId: $PartnerAlertId
    ) {
    PartnerAlerts {
      AlertType
      CreatedAt
      PartnerAlertId
      PartnerId
      ProfileId
      Resolved
      ResolvedAt
      UpdatedAt
    }
    }
  }
`;

export const GetPartnerAlertsByPartner = gql`
  query GetPartnerAlertsByPartner (
      $PartnerId: ID! 
      $Limit: Int 
      $NextToken: String
      $AlertType: String!
    ) {
    GetPartnerAlertsByPartner (
      PartnerId: $PartnerId 
      AlertType: $AlertType 
      Limit: $Limit 
      NextToken: $NextToken
      ) {
      PartnerAlerts {
        AlertType
        CreatedAt
        PartnerAlertId
        PartnerId
        ProfileId
        Resolved
        ResolvedAt
        UpdatedAt
      }
      NextToken
      TotalTokens
    }
  }
`;

export const GetPartnerAlertsByProfile = gql`
  query GetPartnerAlertsByProfile (
      $ProfileId: ID! 
      $Limit: Int 
      $NextToken: String
    ) {
    GetPartnerAlertsByProfile (
      ProfileId: $ProfileId 
      Limit: $Limit 
      NextToken: $NextToken
      ) {
      PartnerAlerts {
        AlertType
        CreatedAt
        PartnerAlertId
        PartnerId
        ProfileId
        Resolved
        ResolvedAt
        UpdatedAt
      }
      NextToken
      TotalTokens
    }
  }
`;

export const UpdatePartnerAlert = gql`
  mutation UpdatePartnerAlert (
      $PartnerAlertId: ID!
      $Resolved: Boolean!
    ) {
    UpdatePartnerAlert (
      Input: {
        Resolved: $Resolved
      }
    ) {
    Id
    }
  }
`;